import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';

import Loader from '@/components/common/Loader';
import { useTenantUsers } from '@/data/tenantUser';
import List from './components/List';
import AddAccountDialog from './AddAccountDialog';

const AccountList = () => {
  const tenantUsers = useTenantUsers();

  let content = <List />;
  if (tenantUsers.isLoading && !tenantUsers.data) {
    content = <Loader />;
  }

  return (
    <>
      <Breadcrumb className="mb-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/setting">Settings</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Accounts</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card>
        <CardHeader>
          <CardTitle className="flex justify-between items-center mb-4">
            Accounts <AddAccountDialog />
          </CardTitle>

          <CardDescription>Manage admin users.</CardDescription>
        </CardHeader>
        <CardContent>{content}</CardContent>
      </Card>
    </>
  );
};

export default AccountList;
